import { MessagesSquare, PenTool, Code2, LifeBuoy } from "lucide-react";

const steps = [
    {
        icon: MessagesSquare,
        title: "Discovery Call",
        description:
            "We start with a focused conversation to understand your business, your customers, and exactly what your new website needs to accomplish.",
    },
    {
        icon: PenTool,
        title: "Design & Approval",
        description:
            "You receive tailored design concepts built around your brand and goals — refined together until every detail feels right.",
    },
    {
        icon: Code2,
        title: "Build & Launch",
        description:
            "Our team develops your site with clean, modern code — fast, mobile-ready, and optimized for search — then launches it to the world.",
    },
    {
        icon: LifeBuoy,
        title: "Ongoing Support",
        description:
            "We keep your site secure, up-to-date, and evolving with your business — so you can focus on running it, not maintaining it.",
    },
];

export default function HowItWorks() {
    return (
        <section
            id="how-it-works"
            data-testid="how-it-works-section"
            className="relative py-24 md:py-32 luxe-radial-faint"
        >
            <div className="max-w-7xl mx-auto px-6 md:px-10 lg:px-16">
                <div className="max-w-3xl">
                    <div className="flex items-center gap-3 mb-6">
                        <div className="gold-rule-solid w-10" />
                        <span className="text-[11px] uppercase tracking-[0.35em] text-[#D4AF37] font-semibold">
                            How It Works
                        </span>
                    </div>
                    <h2 className="font-display text-4xl md:text-5xl lg:text-6xl font-light tracking-tight text-white">
                        From first conversation to{" "}
                        <span className="italic text-gold-metallic">launch day</span>
                        <br className="hidden md:block" /> and beyond.
                    </h2>
                </div>

                {/* Steps */}
                <div className="mt-20 grid md:grid-cols-2 lg:grid-cols-4 gap-px bg-[#D4AF37]/10">
                    {steps.map((s, idx) => {
                        const Icon = s.icon;
                        return (
                            <div
                                key={s.title}
                                data-testid={`how-step-${idx + 1}`}
                                className="group relative bg-black p-8 md:p-10 hover:bg-[#0A0A0A] transition-colors duration-500"
                            >
                                <div className="flex items-baseline justify-between mb-8">
                                    <span className="font-display text-5xl md:text-6xl text-[#D4AF37]/30 group-hover:text-[#D4AF37]/70 transition-colors duration-500">
                                        0{idx + 1}
                                    </span>
                                    <Icon
                                        className="w-6 h-6 text-[#D4AF37]/80"
                                        strokeWidth={1.25}
                                    />
                                </div>

                                <h3 className="font-display text-2xl md:text-[26px] text-white mb-3 leading-tight">
                                    {s.title}
                                </h3>
                                <p className="text-sm leading-relaxed text-[#888] font-light">
                                    {s.description}
                                </p>

                                <div className="absolute bottom-0 left-0 h-px w-0 bg-[#D4AF37] group-hover:w-full transition-all duration-700" />
                            </div>
                        );
                    })}
                </div>
            </div>
        </section>
    );
}
